import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import './index.css'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import { store } from './store'

import './utils/sentry'
import { AWS_SELF_SIGNUP, SELF_SIGNUP } from './config'
import Signup from './routes/Signup'
import { GOOGLE_CLIENT_ID } from './config/google.config'

// ============================================================================
// Global Error Suppression for ResizeObserver
// ============================================================================
// ResizeObserver errors are benign warnings from SunEditor/MathLive
// They don't affect functionality and can be safely suppressed
// Reference: https://github.com/WICG/resize-observer/issues/38

const resizeObserverErrorHandler = (e: ErrorEvent) => {
  const errorMessage = e.message || e.error?.message || ''
  if (
    errorMessage.includes('ResizeObserver loop') ||
    errorMessage.includes('ResizeObserver loop completed')
  ) {
    e.stopImmediatePropagation()
    e.stopPropagation()
    e.preventDefault()
    return false
  }
}

const resizeObserverRejectionHandler = (e: PromiseRejectionEvent) => {
  const errorMessage = e.reason?.message || e.reason?.toString() || ''
  if (errorMessage.includes('ResizeObserver')) {
    e.stopImmediatePropagation()
    e.preventDefault()
    return false
  }
}

window.addEventListener('error', resizeObserverErrorHandler, true)
window.addEventListener(
  'unhandledrejection',
  resizeObserverRejectionHandler,
  true,
)

// Also override the default error handler to catch ResizeObserver errors
const originalConsoleError = console.error
console.error = (...args: any[]) => {
  const errorMessage = args[0]?.toString() || ''
  if (errorMessage.includes('ResizeObserver')) {
    // Suppress ResizeObserver errors in console
    return
  }
  originalConsoleError.apply(console, args)
}

const windowObj: any = window

ReactDOM.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <Router basename={windowObj.SUB_DOMAIN || '/admin'}>
        <Switch>
          <Route path={AWS_SELF_SIGNUP}>
            <Signup />
          </Route>
          <Route path={SELF_SIGNUP}>
            <Signup />
          </Route>
          <Route path="*">
            <App />
          </Route>
        </Switch>
      </Router>
    </Provider>
  </GoogleOAuthProvider>,
  document.getElementById('root'),
)
